import { FactoryFormsModule } from '@b2b/common/factories/forms/forms.factory';
import { ApiService } from '@b2b/common/services/api/types';
import { TODO, UIBModalService } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IQService, ISCEService, IScope, ITimeoutService } from 'angular';
import { TemplatesCreateSchedulesCreateFormsModalsCreateControllerModule } from '../modals/create/controllers/TemplatesCreateSchedulesCreateFormsModalsCreateController';
import { TemplatesCreateSchedulesCreateFormsModalsRemoveControllerModule } from '../modals/remove/controllers/TemplatesCreateSchedulesCreateFormsModalsRemoveController';

export const TemplatesCreateSchedulesCreateFormsControllerModule = angular
  .module('acme.view.application.templates.create.schedules.create.forms.controllers', [
    'ui.router',
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.service.templates',
    'acme.common.service.helpers',
    FactoryFormsModule,
    TemplatesCreateSchedulesCreateFormsModalsCreateControllerModule,
    TemplatesCreateSchedulesCreateFormsModalsRemoveControllerModule,
  ])
  .controller('TemplatesCreateSchedulesCreateFormsController', [
    '$q',
    '$scope',
    '$uibModal',
    '$sce',
    '$state',
    '$timeout',
    'ApiService',
    'TemplatesService',
    'HelpersService',
    'FormsFactory',
    function TemplatesCreateSchedulesCreateFormsController(
      $q: IQService,
      $scope: IScope & { templatesCreateSchedulesCreateForms: TODO },
      $uibModal: UIBModalService,
      $sce: ISCEService,
      $state: StateService,
      $timeout: ITimeoutService,
      ApiService: ApiService,
      TemplatesService: TODO,
      HelpersService: TODO,
      FormsFactory: TODO
    ) {
      const ctrl = {
        model: [] as TODO[],
        forms: [] as TODO[],
        customFields: {} as TODO,
        currentForm: false as TODO | false,
        selectedForm: null as TODO | null,
        schedule: null as TODO | null,
        template: null as TODO | null,
        editor: {} as TODO,
        editorData: {} as TODO,
        previewContainer: false,
        preferences: {
          b2c: {
            display: true,
            required: false,
          },
          pos: {
            display: true,
            required: false,
          },
          kiosk: {
            display: false,
            required: false,
          },
          insideSales: {
            display: false,
            required: false,
          },
        },

        // Channel configuration for template iteration
        channels: [
          {
            id: 'pos',
            label: 'POS',
            key: 'pos',
            showRequire: true,
          },
          {
            id: 'web',
            label: 'Website (B2C)',
            key: 'b2c',
            showRequire: false, // B2C is always required
          },
          {
            id: 'web',
            label: 'Backoffice (B2B)',
            key: 'insideSales',
            showRequire: true,
          },
          {
            id: 'web',
            label: 'Kiosk',
            key: 'kiosk',
            showRequire: true,
          },
        ],

        init: function () {
          ctrl.initData();

          $scope.$on('TemplatesService::Update', ctrl.onTemplatesServiceUpdate);
          $scope.$on(
            'TemplatesCreateSchedulesCreateController::Save',
            ctrl.onTemplatesCreateSchedulesCreateControllerSave
          );
          $scope.$on(
            '$destroy',
            $scope.$watch('templatesCreateSchedulesCreateForms.preferences.b2c.display', ctrl.onB2CPreferencesUpdated)
          );
          $scope.$on(
            '$destroy',
            $scope.$watchCollection('templatesCreateSchedulesCreateForms.preferences.pos', ctrl.onPOSPreferencesUpdated)
          );
          $scope.$on(
            '$destroy',
            $scope.$watchCollection('templatesCreateSchedulesCreateForms.preferences.kiosk', ctrl.onKioskPreferencesUpdated)
          );
          $scope.$on(
            '$destroy',
            $scope.$watchCollection(
              'templatesCreateSchedulesCreateForms.preferences.insideSales',
              ctrl.onInsideSalesPreferencesUpdated
            )
          );
        },

        initData: function () {
          $q.all([
            ApiService.form.list({
              published: '1',
              formCategoryType: 'event',
              ...HelpersService.getPaginator(),
            }),
            ApiService.form.customFields.list(HelpersService.getPaginator()),
          ])
            .then((response) => {
              // TODO: Pretty fragile need to update
              for (let i = 0, ii = response.length; i < ii; i++) {
                if (response[i].config.url.match(/customfields/)) {
                  ctrl.success.getCustomFields(response[i]);
                } else if (response[i].config.url.match(/forms/)) {
                  ctrl.success.getFormList(response[i]);
                }
              }

              if ($state.params && $state.params.scheduleId) {
                ctrl.schedule = TemplatesService.getScheduleById($state.params.scheduleId).schedule;
                const forms = TemplatesService.getScheduleOrderForms(ctrl.schedule);
                if (Array.isArray(forms) && forms.length) {
                  const found = ctrl.findForm(forms[0].id);
                  if (found) {
                    ctrl.selectedForm = found.form;
                    ctrl.selectForm(found.form);
                    ctrl.restoreFormPreferences(forms[0].preferences);
                  }
                }
              } else {
                ctrl.schedule = TemplatesService.getNewSchedule().schedule;
              }
            })
            .catch((response) => ctrl.error.init(response));
        },

        findForm: function (formId) {
          for (let i = 0, ii = ctrl.forms.length; i < ii; i++) {
            if (ctrl.forms[i].id === formId) {
              return {
                index: i,
                form: ctrl.forms[i],
              };
            }
          }

          return false;
        },

        hasForms: function () {
          return Array.isArray(ctrl.forms) && ctrl.forms.length;
        },

        createForm: function () {
          $uibModal
            .open<{ name: string; description: string }>({
              templateUrl: `views/application/views/templates/create/schedules/create/forms/modals/create/create.tpl.html`,
              size: 'md',
              controller: 'TemplatesCreateSchedulesCreateFormsModalsCreateController',
            })
            .result.then((data) => {
              ApiService.form
                .create({
                  name: data.name,
                  description: data.description,
                  type: 'order',
                  source: 'acme',
                  sourceFormUrl: '',
                  sourceFormEditUrl: '',
                })
                .then((response) => ctrl.success.createForm(response))
                .catch((response) => ctrl.error.createForm(response));
            });
        },

        removeForm: function () {
          $uibModal
            .open({
              templateUrl:
                'views/application/views/templates/create/schedules/create/forms/modals/remove/remove.tpl.html',
              size: 'md',
              controller: 'TemplatesCreateSchedulesCreateFormsModalsRemoveController',
            })
            .result.then(() => {
              ctrl.changeForm();
            });
        },

        changeForm: function () {
          TemplatesService.clearScheduleOrderForms(ctrl.schedule);
          ctrl.currentForm = false;
        },

        selectForm: function (form?: TODO) {
          const currentForms: TODO[] = [];

          if (form) {
            ctrl.currentForm = form;
            currentForms.push(ctrl.currentForm);
          }

          if (!ctrl.currentForm.hasOwnProperty('preferences')) {
            ctrl.updateFormPreferences('b2c', ctrl.preferences.b2c);
            ctrl.updateFormPreferences('pos', ctrl.preferences.pos);
            ctrl.updateFormPreferences('kiosk', ctrl.preferences.kiosk);
            ctrl.updateFormPreferences('insideSales', ctrl.preferences.insideSales);
          }

          TemplatesService.setScheduleOrderForms(ctrl.schedule, currentForms);
          ctrl.currentForm = TemplatesService.getScheduleOrderForms(ctrl.schedule)[0];

          // next tick
          $timeout(() => {
            new FormsFactory().renderForm({
              containerId: 'templates-create-schedules-create-forms-preview-form',
              customFields: ctrl.customFields,
              sourceFormDefinition: ctrl.currentForm ? ctrl.currentForm.sourceFormDefinition : false,
            });
          }, 0);
        },

        updateSourceFormDefinition: function () {
          let json = '';

          ctrl.editorData = ctrl.editor.data('formBuilder');
          try {
            json = JSON.stringify(JSON.parse(ctrl.editorData.formData));
          } catch (e) {
            console.error('OrdersFormsController::updateSourceFormDefinition', 'Failed to parse formData JSON');
          }
          ctrl.currentForm.sourceFormDefinition = json;
        },

        updateFormPreferences: function (channel, preferences) {
          if (ctrl.selectedForm) {
            if (!ctrl.selectedForm.preferences) {
              ctrl.selectedForm.preferences = new FormsFactory().getDefaultNamedPreferences();
            }

            ctrl.selectedForm.preferences[channel] = new FormsFactory().updatePreferences(channel, preferences)[
              channel
            ];
          }
        },

        restoreFormPreferences: function (preferences) {
          const channels = ['pos', 'b2c', 'kiosk', 'insideSales'];

          for (let i = 0, ii = channels.length; i < ii; i++) {
            ctrl.preferences[channels[i]] = new FormsFactory().restorePreferences(preferences)[channels[i]];
          }
        },

        getFormList: function () {
          ApiService.form
            .list({ published: '1', ...HelpersService.getPaginator() })
            .then((response) => ctrl.success.getFormList(response))
            .catch((response) => ctrl.error.getFormList(response));
        },

        getCustomFields: function () {
          ApiService.form.customFields
            .list()
            .then((response) => ctrl.success.getCustomFields(response))
            .catch((response) => ctrl.error.getCustomFields(response));
        },

        storeFormMetadata: function (formData) {
          ApiService.form
            .create(formData)
            .then((response) => ctrl.success.storeFormMetadata(response))
            .catch((response) => ctrl.error.storeFormMetadata(response));
        },

        processCustomFields: function (fields: TODO[]) {
          const result = {
            none: '-- No Custom Field --',
          };

          for (let i = 0, ii = fields.length; i < ii; i++) {
            if (fields[i].active) {
              result[fields[i].id + '%%' + fields[i].name + '%%' + fields[i].label] = fields[i].label;
            }
          }

          return result;
        },

        success: {
          init: function (response) {},
          getFormList: function (response) {
            ctrl.forms = response.data.payload.list;
          },
          getCustomFields: function (response) {
            //ctrl.customFields = response.data.payload.list;
            ctrl.customFields = ctrl.processCustomFields([
              {
                id: 1,
                name: 'field1',
                label: 'age',
                active: true,
                format: 'text',
                values: '',
              },
              {
                id: 1,
                name: 'field2',
                label: 'food',
                active: true,
                format: 'text',
                values: '',
              },
              {
                id: 1,
                name: 'field3',
                label: 'handicap',
                active: true,
                format: 'text',
                values: '',
              },
              {
                id: 1,
                name: 'field4',
                label: 'seating',
                active: true,
                format: 'text',
                values: '',
              },
              {
                id: 1,
                name: 'field5',
                label: 'smoking',
                active: true,
                format: 'text',
                values: '',
              },
            ]);
          },
          createForm: function (response) {
            // Open form editor
            ctrl.currentForm = response.data.payload;
            ctrl.selectForm();
          },

          storeFormMetadata: function (response) {
            ctrl.getFormList();
          },
          removeForm: function (response) {
            TemplatesService.clearScheduleOrderForms(ctrl.schedule);
            ctrl.currentForm = false;
            ctrl.getFormList();
          },
        },

        error: {
          init: function (response) {},
          getFormList: function (response) {},
          getCustomFields: function (response) {},
          createForm: function (response) {},
          storeFormMetadata: function (response) {
            console.log(response);
          },
        },

        onFormSelect: function () {
          $timeout(() => {
            ctrl.selectForm(ctrl.selectedForm);
          }, 10);
        },

        onTemplatesCreateSchedulesCreateControllerSave: function (e, data) {
          const forms = angular.toJson(TemplatesService.getScheduleOrderForms(ctrl.schedule));

          if (ctrl.currentForm) {
            TemplatesService.setScheduleOrderForms(ctrl.schedule, [ctrl.currentForm]);
            TemplatesService.setScheduleById(ctrl.schedule.id, ctrl.schedule);
          } else {
            TemplatesService.clearScheduleOrderForms(ctrl.schedule);
          }
        },

        onTemplatesServiceUpdate: function (e, data) {
          ctrl.template = TemplatesService.getModel();

          // Next Tick
          $timeout(() => {
            if (ctrl.schedule && TemplatesService.hasScheduleOrderForms(ctrl.schedule)) {
              // Always accepts a list of forms
              const forms = TemplatesService.getScheduleOrderForms(ctrl.schedule);
              if (Array.isArray(forms) && forms.length) {
                const found = ctrl.findForm(forms[0].id);
                if (found) {
                  ctrl.selectedForm = found.form;
                  ctrl.selectForm(found.form);
                  ctrl.restoreFormPreferences(forms[0].preferences);
                }
              }
            }
          }, 0);
        },

        onB2CPreferencesUpdated: function (n, o) {
          if (n !== o) {
            ctrl.updateFormPreferences('b2c', { display: n });
          }
        },

        onPOSPreferencesUpdated: function (n, o) {
          if (n !== o) {
            ctrl.updateFormPreferences('pos', n);
          }
        },
        
        onKioskPreferencesUpdated: function (n, o) {
          if (n !== o) {
            ctrl.updateFormPreferences('kiosk', n);
          }
        },

        onInsideSalesPreferencesUpdated: function (n, o) {
          if (n !== o) {
            ctrl.updateFormPreferences('insideSales', n);
          }
        },
      };

      $scope.templatesCreateSchedulesCreateForms = ctrl;
      ctrl.init();
    },
  ]).name;
